<template>
  <div class="clientes">
    <h1 class="titulo-card fs-4">Grupos de IP Pool's / IP Pool's</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="$router.go(-1)" class="btn btn-outline-primary">
            <font-awesome-icon :icon="['fas', 'arrow-left']" fixed-width class="me-1"/>Voltar
          </button>
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">#</th>
              <th>Identificação da Pool</th>
              <th width="120">Pool CIDR</th>
              <th width="130">Destino</th>
              <th width="85">Camada IP</th>
              <th width="75"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="ipPool in listaItens" :key="ipPool.id">
                <td scope="row">{{ipPool.id}}</td>
                <td>{{ipPool.descricao}}</td>
                <td>{{ipPool.cidr}}</td>
                <td>{{ipPool.tipo_grupo}}</td>
                <td>{{ipPool.tipo_ip}}</td>
                <td class="text-end">
                  <button type="button" v-on:click="handleEditaIPPool(ipPool)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleRemoveIPPool(ipPool)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>

              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

      <!-- modal-edita-ip-pool -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-ip-pool" id="btn-modal-edita-ip-pool-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-edita-ip-pool" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="!modal.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Cadastrar novo IP-Pool
              </h5>
              <h5 v-if="!!modal.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
                Editando IP-Pool
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-5">
                  <label class="required">Identificação</label>
                  <input type="text" v-model="modal.data.descricao" class="form-control">
                </div>
                <div class="col-12 col-sm-4 col-md-3 col-lg-3">
                  <label class="required">Pool CIDR</label>
                  <input type="text" v-model="modal.data.cidr" class="form-control" placeholder="100.64.0.0/10">
                </div>
                <div class="col-12 col-sm-4 col-md-3 col-lg-2">
                  <label class="required">Destino</label>
                  <select v-model.number="modal.data.tipo_grupo" class="form-select">
                    <option value="undefined" disabled>Selecione</option>
                    <option value="tgDistribuicao">Distribuição</option>
                    <option value="tgBloqueio">Bloqueio</option>
                    <option value="tgNaoAutenticados">Não autenticados</option>
                  </select>
                </div>
                <div class="col-12 col-sm-4 col-md-3 col-lg-2">
                  <label class="required">Camada IP</label>
                  <select v-model.number="modal.data.tipo_ip" class="form-select">
                    <option value="undefined" disabled>Selecione</option>
                    <option value="tiIPv4">IPv4</option>
                    <option value="tiIPv6" disabled>IPv6</option>
                    <option value="tiIPv6PD" disabled>IPv6 prefix delegation</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-ip-pool-fecha">Fechar</button>
              <button type="button"
                  v-if="!modal.data.id"
                  v-on:click="handlemodalCadastrar()"
                  v-bind:disabled="!podeSalvarIPPool()"
                  class="btn btn-success">
                Cadastrar
              </button>
              <button type="button"
                  v-if="!!modal.data.id"
                  v-on:click="handlemodalSalvar()"
                  v-bind:disabled="!podeSalvarIPPool()"
                  class="btn btn-success">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-edita-ip-pool -->
    </div>
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'IPPools',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaItens: [],
      modal: {
        data: {
          id: undefined,
          descricao: '',
          cidr: '',
          tipo_grupo: '',
          tipo_ip: '',
        },
      }
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/ip-pools?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaItens = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.resetmodal();
      this.abreModalCadastroIPPool();
    },

    async handleEditaIPPool(ipPool) {
      this.resetmodal();

      this.modal.data = clone(ipPool);

      this.abreModalCadastroIPPool();
    },

    handleRemoveIPPool(ipPool) {
      dialogo.confirmacao(`Confirma remover o Grupo <b>${ipPool.descricao}</b>?`).then(() => {
        loading(true);

        api.delete(`/ip-pools/${ipPool.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    abreModalCadastroIPPool() {
      document.getElementById('btn-modal-edita-ip-pool-abre').click();
    },

    resetmodal() {
      this.modal.data.id = undefined;
      this.modal.data.descricao = '';
      this.modal.data.cidr = '';
      this.modal.data.tipo_grupo = '';
      this.modal.data.tipo_ip = '';
    },

    podeSalvarIPPool() {
      switch (true) {
        case (this.modal.data.descricao.length < 3):
        case (this.modal.data.cidr.length < 9):
        case (!this.modal.data.tipo_grupo):
        case (!this.modal.data.tipo_ip):
          return false;

        default:
          return true;
      }
    },

    handlemodalCadastrar() {
      const sendData = {...this.modal.data};

      loading(true);

      api.post('/ip-pools', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-ip-pool-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handlemodalSalvar() {
      const sendData = {...this.modal.data};

      loading(true);
      api.put(`/ip-pools/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-ip-pool-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
  },
  created() {
    this.handlePesquisa();

    // document.getElementById('btn-modal-edita-ip-pool-fecha').click();
    /*
    setTimeout(() => {
      this.handleAdicionar();

      this.modal.data.descricao = 'BNG Teste Front';
      this.modal.data.senha_radius = '123465';
      this.modal.data.pool_ipv4_acesso_id = 0;
      this.modal.data.pool_ipv4_bloqueio_id = 0;
    }, 500);
    /* */
  }

}


</script>
